<script lang="ts">
  import { Button } from '@centerhealth/fe/center-kit';
</script>

<section class="error-wrapper mt-7">
  <div class="container mx-auto text-center">
    <p class="pretitle text-lg mb-1">Uh oh!</p>
    <p class="text-xl text-gray-darkest font-semibold mb-5">That page doesn't exist!</p>
    <p class="text-base mb-6 text-gray">
      I swear it was here a minute ago. Well, that's embarrassing.
    </p>
    <Button href="/">Go back to homepage</Button>
  </div>
</section>

<style>
  .pretitle {
    color: #aaa;
  }
  .error-wrapper {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-height: 620px;
    text-align: center;
    background-image: url('/assets/images/error.png');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: auto 300px;
    font-size: 0;
  }
</style>
